import { useTranslation } from "@emisgroup/acp-application-intl";

export const usePracticeTable = (): { columns } => {
  const { t: translate } = useTranslation();
  const columns = [
    {
      key: "name",
      header: translate("PracticesList.Heading.Name"),
      sortable: true,
      width: "250px"
    },
    {
      key: "cdb",
      header: translate("PracticesList.Heading.CDB"),
      sortable: true,
      width: "200px"
    },
    {
      key: "included",
      header: translate("PracticesList.Heading.Included"),
      render: (value) => value?.toLocaleString() || "-"
    },
    {
      key: "excluded",
      header: translate("PracticesList.Heading.Excluded"),
      render: (value) => value?.toLocaleString() || "-"
    },
    {
      key: "population",
      header: translate("PracticesList.Heading.Population"),
      render: (value) => value?.toLocaleString() || "-"
    }
  ];

  return {
    columns
  };
};
